import { getProfileNameAndInitials } from '@/util/getProfileNameAndInitials';

/**
 * Expert-relay caption: “Dr. {last}” when applicable, otherwise full display name.
 *
 * Kept in a pure module so the message plan can derive the caption without
 * pulling the bubble component tree in behind it.
 */
export function getExpertRelayCaptionLabel(expert: {
  firstName?: string | null;
  lastName?: string | null;
  identifiesAsDoctor?: boolean | null;
}) {
  const trimmedLastName = expert.lastName?.trim();

  if (expert.identifiesAsDoctor && trimmedLastName) {
    return `Dr. ${trimmedLastName}`;
  }

  return getProfileNameAndInitials({
    firstName: expert.firstName ?? '',
    lastName: expert.lastName ?? '',
    identifiesAsDoctor: Boolean(expert.identifiesAsDoctor),
  }).name;
}
